<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
    <app-header [page]="'Admin'"></app-header>
<main class="container py-4">

  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h4 class="fw-bold mb-0">KYC Policies</h4>
      <div class="text-muted small">
        Manage policies that define fields, documents and rules for users
      </div>
    </div>

    <div class="d-flex gap-2">
      <a class="btn btn-outline-secondary btn-sm" routerLink="/admin/compliance">
        Back
      </a>
      <button class="btn btn-primary btn-sm" (click)="createNew()">
        New Policy
      </button>
    </div>
  </div>

  <div class="card shadow-sm border-0 mb-4">
    <div class="card-body">
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label small">Jurisdiction</label>
          <select class="form-select" [(ngModel)]="filter.jurisdictionId">
            <option value="">All</option>
            <option *ngFor="let item of jurisdictions" [value]="item.id">
              {{ item.code }} - {{ item.name }}
            </option>
          </select>
        </div>

        <div class="col-md-2">
          <label class="form-label small">Customer Type</label>
          <select class="form-select" [(ngModel)]="filter.customerType">
            <option value="">All</option>
            <option *ngFor="let item of customerTypes" [ngValue]="item.value">
              {{ item.label }}
            </option>
          </select>
        </div>

        <div class="col-md-2">
          <label class="form-label small">Product Type</label>
          <select class="form-select" [(ngModel)]="filter.productType">
            <option value="">All</option>
            <option *ngFor="let item of productTypes" [ngValue]="item.value">
              {{ item.label }}
            </option>
          </select>
        </div>

        <div class="col-md-2">
          <label class="form-label small">Tier Code</label>
          <input class="form-control"
                 [(ngModel)]="filter.tierCode"
                 placeholder="BASIC" />
        </div>

        <div class="col-md-2">
          <label class="form-label small">Status</label>
          <select class="form-select" [(ngModel)]="filter.status">
            <option value="">All</option>
            <option *ngFor="let item of policyStatuses" [ngValue]="item.value">
              {{ item.label }}
            </option>
          </select>
        </div>

        <div class="col-md-1">
          <label class="form-label small">Size</label>
          <select class="form-select" [(ngModel)]="filter.pageSize">
            <option [ngValue]="">Default</option>
            <option [ngValue]="10">10</option>
            <option [ngValue]="20">20</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
          </select>
        </div>
      </div>

      <div class="mt-3 d-flex gap-2">
        <button class="btn btn-primary btn-sm" (click)="load()">Apply</button>
        <button class="btn btn-outline-secondary btn-sm" (click)="resetFilters()">Reset</button>
      </div>
    </div>
  </div>

  <div *ngIf="loading || lookupsLoading" class="text-center py-4">
    <div class="spinner-border"></div>
  </div>

  <div *ngIf="error" class="alert alert-danger">
    {{ error }}
  </div>

  <div *ngIf="!loading && !lookupsLoading && !items.length" class="alert alert-light border">
    No policies found.
  </div>

  <div *ngIf="items.length && !loading" class="card shadow-sm border-0">
    <div class="table-responsive">
      <table class="table table-hover align-middle mb-0">
        <thead class="table-light">
          <tr>
            <th>Name</th>
            <th>Tier</th>
            <th>Jurisdiction</th>
            <th>Customer</th>
            <th>Product</th>
            <th>Version</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let item of items">
            <td class="fw-semibold">{{ item.name }}</td>
            <td>{{ item.tierCode }}</td>
            <td>{{ getJurisdictionLabel(item) }}</td>
            <td>{{ getCustomerTypeLabel(item.customerType) }}</td>
            <td>{{ getProductTypeLabel(item.productType) }}</td>
            <td>{{ item.version }}</td>

            <td>
              <span class="badge" [ngClass]="getStatusBadgeClass(item.status)">
                {{ getStatusLabel(item.status) }}
              </span>
            </td>

            <td class="text-end">
              <button class="btn btn-sm btn-outline-primary" (click)="edit(item)">
                Edit
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <app-pagination *ngIf="meta && meta.totalRows > 0" [url]='url' [counts]='meta!' (refresh)="onPageLoad($event)"></app-pagination>
    </div>
  </div>

  <app-footer></app-footer>
</main>
</div>